import { cn } from '@resolute/ui';

import { EASE_OUT_EXPO } from '@/lib/motion';

/** Shared class for every top-level nav link (desktop row and mobile list). */
export const linkClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    'rounded-md px-3 py-2 text-sm font-medium transition-colors duration-fast ease-out-expo hover:bg-muted',
    isActive ? 'text-primary' : 'text-foreground',
  );

/** Transition for every shared sliding highlight (navbar/sidebar/grid items).
 *  A duration-based ease-out, not a spring — a spring can overshoot and wobble
 *  visibly on longer hover-to-hover travel distances (e.g. a grid item all
 *  the way across and down from the currently-hovered one), where a tween
 *  can't, by construction.
 *
 *  180ms: this highlight chases the cursor, so it has to arrive about as fast
 *  as the pointer does. At the previous 280ms it visibly trailed behind a
 *  normal hover sweep across the nav, which read as lag rather than polish. */
export const highlightTransition = (reduce: boolean | null) =>
  reduce ? { duration: 0 } : { duration: 0.18, ease: EASE_OUT_EXPO };
